(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ProtvistaTrack"));
	else if(typeof define === 'function' && define.amd)
		define(["ProtvistaTrack"], factory);
	else if(typeof exports === 'object')
		exports["ProtvistaInterproTrack"] = factory(require("ProtvistaTrack"));
	else
		root["ProtvistaInterproTrack"] = factory(root["ProtvistaTrack"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 